import { Flag, UnitDropdownField, useFormattedIntegerMask } from "@wayflyer/flyui";
import { COUNTRY_CURRENCY_MAP, getCurrencySymbol } from "shared-utils";
import { useIntl } from "react-intl";

const MCA_CURRENCY_PREFIX_MAP = {
  AUD: getCurrencySymbol("AUD"),
  CAD: getCurrencySymbol("CAD"),
  DKK: getCurrencySymbol("DKK"),
  EUR: getCurrencySymbol("EUR"),
  GBP: getCurrencySymbol("GBP"),
  SEK: getCurrencySymbol("SEK"),
  USD: getCurrencySymbol("USD", "narrowSymbol"),
};

const convertAmount = (revenue?: string | number): number => {
  return revenue === null || revenue === undefined || revenue === "" ? 0 : +revenue;
};

export interface CurrencyInputProps {
  name: string;
  label: string;
  onChange: ({ unitId, unitValue }: { unitId: any; unitValue: any }) => void;
  defaultValue?: number;
  defaultCurrency?: string;
  error?: string;
  helperText?: string;
  analyticAttributes?: Record<string, string>;
}

export const CurrencyInput = ({
  name,
  label,
  onChange,
  defaultValue,
  defaultCurrency,
  error,
  helperText,
  analyticAttributes,
}: CurrencyInputProps) => {
  const intl = useIntl();
  const formattedIntegerMask = useFormattedIntegerMask({ maxDigits: 10 });
  const currencyUnitOptions = Object.entries(COUNTRY_CURRENCY_MAP).map(([countryCode, currencyCode]) => {
    return {
      id: currencyCode,
      text: `${intl.formatDisplayName(currencyCode, { type: "currency" })}`,
      icon: <Flag code={countryCode} />,
    };
  });

  const defaultCurrencyOption = {
    id: "USD",
    text: `${intl.formatDisplayName("USD", { type: "currency" })}`,
    icon: <Flag code="US" />,
  };

  return (
    <UnitDropdownField
      name={name}
      label={label}
      helperText={helperText}
      prefixMap={MCA_CURRENCY_PREFIX_MAP}
      defaultUnit={currencyUnitOptions.find((unit) => unit.id === defaultCurrency) || defaultCurrencyOption}
      defaultValue={defaultValue || undefined}
      unitOptions={currencyUnitOptions}
      mask={formattedIntegerMask}
      // @todo: this convertAmount function should not be necessary
      onChange={({ unitId, unitValue }) => onChange({ unitId, unitValue: convertAmount(unitValue) })}
      error={error}
      analyticAttributes={analyticAttributes}
    />
  );
};
